<template>
  <div class="tw-my-[30xp]">
    <div
      v-for="(w, key) in words"
      :key="key"
      class="tw-relative tw-inline-block tw-m-[10px]"
    >
      <a
        href=""
        v-if="results[key] === undefined"
        @click.prevent="selectOption(key)"
        class="tw-block tw-p-[10px] tw-border tw-border-solid tw-text-primary 
          tw-border-primary tw-no-underline hover:tw-bg-primaryvlt"
      >
        {{ w.value }}
      </a>
      <span
        v-else
        class="tw-block tw-p-[10px] tw-border tw-border-solid tw-border-primary 
          tw-text-primary tw-opacity-50"
      >
        {{ w.value }}
      </span>
      <div 
        v-if="results[key] !== undefined" 
        class="tw-absolute tw-top-[-12px] tw-right-[-19px]"
      >
        <ResultMark :result="results[key] > 0" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ResultMark from "./ResultMark.vue";
import { sfActivityCurrentWord } from "@/state/sfActivityState";

export default defineComponent({
  components: { ResultMark },
  emits: ["success"],
  data() {
    return {
      results: [] as number[],
    };
  },
  computed: {
    words() {
      return sfActivityCurrentWord.value?.wordOptions;
    },
  },
  methods: {
    selectOption(keyId: number) {
      if (!this.words) {
        return;
      }
      let key = keyId;
      let option = this.words[key];
      let results = [...this.results];
      if (option.value == sfActivityCurrentWord.value?.value) {
        results[key] = 1;
        setTimeout(() => {
          this.$emit("success");
        }, 1000);
      } else {
        results[key] = -1;
      }
      this.results = results;
    },
  },
});
</script>
